// NO CHILL MERCH — tiny visual polish only. No Shopify backend/cart logic changed.
(() => {
  document.documentElement.classList.add('no-chill-ui');

  // Ref-counted page lock. overflow:hidden on body is not enough on iOS: the document still
  // scrolls behind the menu, cart, size guide and media zoom. Opening one overlay must not
  // unlock another that is still open.
  window.NcmScrollLock = {
    count: 0,
    y: 0,
    lock() {
      if (this.count++ > 0) return;
      this.y = window.scrollY;
      document.documentElement.classList.add('ncm-scroll-locked');
      document.body.classList.add('ncm-scroll-locked');
      document.body.style.top = `-${this.y}px`;
    },
    unlock() {
      if (this.count === 0) return;
      if (--this.count > 0) return;
      document.documentElement.classList.remove('ncm-scroll-locked');
      document.body.classList.remove('ncm-scroll-locked');
      document.body.style.top = '';
      window.scrollTo({ top: this.y, left: 0, behavior: 'instant' });
    },
  };

  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) {
    const updateHeader = () => {
      header.classList.toggle('nc-scrolled', window.scrollY > 18);
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-ugc-marquee]').forEach((marquee) => {
    const track = marquee.querySelector('.ugc-track');
    if (!track) return;

    const pause = () => marquee.classList.add('is-paused');
    const play = () => marquee.classList.remove('is-paused');

    marquee.addEventListener('touchstart', pause, { passive: true });
    marquee.addEventListener('touchend', play, { passive: true });
    marquee.addEventListener('touchcancel', play, { passive: true });
  });
})();
